/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OnboardingHookEvent,
  OnboardingHookEvent$inboundSchema,
} from "./onboardinghookevent.js";

export type VerifyOnboardingHooksSetupResult = {
  /**
   * Recent hook events, newest first. Truncated to a server-defined limit.
   */
  events: Array<OnboardingHookEvent>;
  /**
   * Highest time_unix_nano in this batch. Pass back as since_unix_nano on the next poll.
   */
  latestUnixNano: string;
  /**
   * Total events received with time_unix_nano greater than since_unix_nano. May exceed len(events) when truncated.
   */
  totalCount: number;
};

/** @internal */
export const VerifyOnboardingHooksSetupResult$inboundSchema: z.ZodMiniType<
  VerifyOnboardingHooksSetupResult,
  unknown
> = z.pipe(
  z.object({
    events: z.array(OnboardingHookEvent$inboundSchema),
    latest_unix_nano: z.string(),
    total_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "latest_unix_nano": "latestUnixNano",
      "total_count": "totalCount",
    });
  }),
);

export function verifyOnboardingHooksSetupResultFromJSON(
  jsonString: string,
): SafeParseResult<VerifyOnboardingHooksSetupResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VerifyOnboardingHooksSetupResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VerifyOnboardingHooksSetupResult' from JSON`,
  );
}
